import React from 'react';
import GameRulesText from '../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="pairing" />
    </p>
  </>
);

export default RulesOfTheGame;
